import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GetMeetingRoomSchedulesInput, MeetingRoomScheduleInput, MeetingRoomScheduleResult, Result, ResultList, SingleResult } from 'app/models';
import { Utility } from 'app/shared';
import { plainToClassFromExist } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class MeetingRoomScheduleService {

  constructor(private httpClient: HttpClient) { }

  public addMeetingRoomSchedule(meetingRoomScheduleInput: MeetingRoomScheduleInput): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'MeetingRoomSchedule/AddMeetingRoomSchedule', meetingRoomScheduleInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public editMeetingRoomSchedule(id: number, meetingRoomScheduleInput: MeetingRoomScheduleInput): Promise<Result> {
    return this.httpClient.put(Utility.serviceAddress + 'MeetingRoomSchedule/EditMeetingRoomSchedule?id=' + id, meetingRoomScheduleInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public deleteMeetingRoomSchedule(id: number): Promise<Result> {
    return this.httpClient.delete(Utility.serviceAddress + 'MeetingRoomSchedule/DeleteMeetingRoomSchedule?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getMeetingRoomSchedules(getMeetingRoomSchedulesInput: GetMeetingRoomSchedulesInput, token: string): Promise<ResultList<MeetingRoomScheduleResult>> {
    return this.httpClient.post(Utility.serviceAddress + 'MeetingRoomSchedule/GetMeetingRoomSchedules', getMeetingRoomSchedulesInput, Utility.options(token))
      .toPromise().then(result => plainToClassFromExist(new ResultList<MeetingRoomScheduleResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<MeetingRoomScheduleResult>(), result.error));
  }

  public getMeetingRoomSchedulesExportToExcel(getMeetingRoomSchedulesInput: GetMeetingRoomSchedulesInput): Promise<SingleResult<Uint8Array>> {
    return this.httpClient.post(Utility.serviceAddress + 'MeetingRoomSchedule/GetMeetingRoomSchedulesExportToExcel', getMeetingRoomSchedulesInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new SingleResult<Uint8Array>(Uint8Array), result))
      .catch(result => plainToClassFromExist(new SingleResult<Uint8Array>(Uint8Array), result.error));
  }

  public getMeetingRoomSchedule(id: number, token: string): Promise<SingleResult<MeetingRoomScheduleResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'MeetingRoomSchedule/GetMeetingRoomSchedule?id=' + id, Utility.options(token))
      .toPromise().then(result => plainToClassFromExist(new SingleResult<MeetingRoomScheduleResult>(MeetingRoomScheduleResult), result))
      .catch(result => plainToClassFromExist(new SingleResult<MeetingRoomScheduleResult>(MeetingRoomScheduleResult), result.error));
  }
}
